import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { ResponsivePictureLayout } from '@news-mono/component-library'
import { Store } from '@news-mono/web-common'
import { layout } from '../../App.routing'

export const businessSegment = (store: Store) => {
    const isCNBCEnabled = isFeatureEnabled(
        toFeatureState(store.getState().toggles),
        'the-west-cnbc',
        false,
    )

    return [
        layout.component({
            type: 'sierra',
            props: {
                verticalSpacing: 'gridGap',
                fixedRatios: ['16:9'],
                heroImageLayout: ResponsivePictureLayout.ObjectFitContain,

                cardOrientation: {
                    type: 'Landscape-Portrait',
                    maxBreakpoint: 'md',
                },
                cardLayout: [
                    { type: 'hero', disableImageLazyLoad: false },
                    'teaser-xsVisible-mdHidden-Image',
                ],
                sectionHeader: {
                    heading: 'Business',
                    headingUrl: '/business',
                    section: 'business',
                },

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'business',
                    offset: 0,
                    pageSize: 2,
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fixedRatios: ['16:9'],
                intermediateColumns: 2,
                finalColumns: 4,
                teaserMode: 'hidden',
                hideByline: false,
                hasBackground: true,
                cardLayout: [
                    ['teaserWithBackground'],
                    ['xsImage-mdNoImage-withBG', 'xsImage-mdNoImage-withBG'],
                    ['teaserWithBackground'],
                    { type: 'november', listLength: 5, minimumCards: 5 },
                ],
                cardOrientation: { type: 'Landscape-Portrait' },

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'business',
                    offset: 2,
                    pageSize: 9,
                },
                hasBorder: !isCNBCEnabled,
            },
        }),
    ]
}
